import { Controller } from '@hotwired/stimulus'
import hljs from 'highlight.js/lib/core'
import json from 'highlight.js/lib/languages/json'

// Connects to data-controller="highlight"
export default class extends Controller<HTMLElement> {
  initialize (): void {
    hljs.registerLanguage('json', json)
  }

  connect (): void {
    hljs.highlightElement(this.element)
  }
}
